import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form,  Row, Col } from "react-bootstrap";
import { updateDb } from "../services/updateDb";

import { useTranslation } from "react-i18next";

function ApproveRequestModal({ reqObj, show, handleClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    // Initialize initial state and reset reason when the modal is shown or when riskObj changes
    if (show) {
        // reset form
        document.getElementById("approveRequest").reset();
    }
  }, [show, reqObj]);


  if (reqObj && reqObj.id) {
    return (
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Approve request</Modal.Title>
        </Modal.Header>
        <Modal.Body className="update-score-modal">
          <Form id="approveRequest">

            <b>Request:</b>

            <Row className="mb-3">
                <Col>Name:</Col>
                <Col>{reqObj.name}</Col>
            </Row>

            <Row className="mb-3">
                <Col>Email:</Col>
                <Col>{reqObj.email}</Col>
            </Row>

            <Row className="mb-3">
                <Col>Organization:</Col>
                <Col>{reqObj.orgName}</Col>
            </Row>

            <Row className="mb-3">
                <Col>Domain:</Col>
                <Col>{reqObj.projectName}</Col>
            </Row>


            <Row className="mb-3">
                <Col>Environment (environment.risqui.nl):</Col>
                <Col>
                    <Form.Control as="input" name="environment-name" defaultValue={reqObj.environmentName} />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col>Import Risk Templates:</Col>
                <Col>
                    <Form.Select name="import-risk-templates">
                        <option value="true">Yes, import risk templates</option>
                        <option value="false">No, dont import</option>
                    </Form.Select>
                </Col>
            </Row>



            <Row className="mb-3">
                <Col>Trial duration:</Col>
                <Col>
                    <Form.Select name="trial-duration" defaultValue={reqObj.specialEvent ? "7776000" : "2592000"}>
                        <option value="604800">7 days</option>
                        <option value="1209600">14 days</option>
                        <option value="2592000">30 days</option>
                        <option value="5184000">60 days</option>
                        <option value="7776000">90 days</option>
                    </Form.Select>
                </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>

        <div className="white-border-btn cancel-btn" onClick={() => handleClose(false)}>{t('cancel')}</div>
        
        <div style={{flexGrow: 1}} />
        
        <div className="white-border-btn submit-btn" onClick={() => handleClose(true, {
            "id": reqObj.id,
            "environmentName": document.querySelector("input[name='environment-name']").value,
            "importRiskTemplates": document.querySelector("select[name='import-risk-templates']").value == "true" ? true : false,
            "trialDuration": document.querySelector("select[name='trial-duration']").value,
          })}>{t('approve')}</div>


        </Modal.Footer>
      </Modal>
    );
  } 
}

export default ApproveRequestModal;
